module.exports = __webpack_public_path__ + "static/media/clients-04.1dbd8efe.svg";